module.exports = __webpack_public_path__ + "static/img/DWT.a9a99af.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/leven/DWT.jpg
// module id = Jwfk
// module chunks = 1